type TrimRange = { trimmedStartTimeSeconds: number; trimmedEndTimeSeconds?: number | null };

// returns the offset start time, given a start time (relative to a full video) and a trimmed start time
export const getStartTimeForDisplay = (startTimeSeconds: number, trimmedStartTimeSeconds: number = 0) => {
  return Math.max(startTimeSeconds - trimmedStartTimeSeconds, 0);
};

// returns the offset end time, given a end time (relative to a full video) and a trimmed start time
export const getEndTimeForDisplay = (endTimeSeconds: number, trimRange: TrimRange) => {
  const { trimmedStartTimeSeconds, trimmedEndTimeSeconds = 0 } = trimRange ?? {};
  if (!trimmedEndTimeSeconds) {
    return endTimeSeconds;
  }
  return Math.min(endTimeSeconds - trimmedStartTimeSeconds, trimmedEndTimeSeconds);
};

export const getIsOutsideTrimmingRange = (startTimeSeconds: number, endTimeSeconds?: number, trimRange?: TrimRange) => {
  const { trimmedStartTimeSeconds = 0, trimmedEndTimeSeconds } = trimRange ?? {};
  if (endTimeSeconds && endTimeSeconds < trimmedStartTimeSeconds) {
    return true;
  }
  if (trimmedEndTimeSeconds && startTimeSeconds > trimmedEndTimeSeconds) {
    return true;
  }

  return false;
};
